import { RuleTableHandlers, TableConfig } from '../../../../shared/ui/custom-table/model/table-config.model';

export function createContactTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string, defaultFilter?: any, showCreateUserOption?: boolean } = {}
): TableConfig {

  const {
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    summaryTemplate = () => { },
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  const actions: any[] = [
    { label: 'Editar', icon: 'edit', callback: row => handleAction(row, TableRowAction.Edit) },
    { label: 'Histórico', icon: 'history', callback: row => handleAction(row, TableRowAction.History) },
    { label: 'Excel extracto contable', icon: 'file_download', callback: row => handleAction(row, TableRowAction.Statement) },
    { label: 'Mayor contable cliente', icon: 'description', visible: (row: any) => !!row && row.isClient, callback: row => handleAction(row, TableRowAction.LedgerClient) },
    { label: 'Mayor contable proveedor', icon: 'description', visible: (row: any) => !!row && row.isProvider, callback: row => handleAction(row, TableRowAction.LedgerProvider) },
    { label: 'Cuentas bancarias', icon: 'credit_card', callback: row => handleAction(row, TableRowAction.BankAccounts) },
    { label: 'Centros', icon: 'store', callback: row => handleAction(row, TableRowAction.Centers) },
    { label: 'Portal del cliente', icon: 'public', visible: (row: any) => !!row && row.isClient, callback: row => handleAction(row, TableRowAction.CustomerPortal) },
    { label: 'Sincronizar con Bookcit', icon: 'sync', callback: row => handleAction(row, TableRowAction.SyncBookcit) },
  ];

  if (options.showCreateUserOption) {
    actions.push({ label: 'Crear cuenta Handly', icon: 'person_add', callback: row => handleAction(row, TableRowAction.CreateUser) });
  }

  actions.push({ label: 'Eliminar', icon: 'delete', callback: row => handleAction(row, TableRowAction.Delete) });

  return {
    columns: columns,
    actions: actions,
    gridActions: gridActions,
    headerActions: headerActions,
    filterView: options.filterView || 'viewContactFilters',
    defaultFilter: options.defaultFilter || {},
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: false,
    summaryTemplate: summaryTemplate
  };
}

export enum TableRowAction {
  Edit = 'edit',
  Delete = 'delete',
  History = 'history',
  Statement = 'statement',
  LedgerClient = 'ledgerClient',
  LedgerProvider = 'ledgerProvider',
  BankAccounts = 'bankAccounts',
  Centers = 'centers',
  CreateUser = 'createUser',
  SyncBookcit = 'syncBookcit',
  CustomerPortal = 'customerPortal',
}
